class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.initHoverOpen();
  }

  initHoverOpen() {
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');

    if (this.hoverMediaQuery.matches) {
      this.bindHoverOpen();
    }

    this.hoverMediaQuery.addEventListener('change', (event) => {
      if (event.matches) {
        this.bindHoverOpen();
      } else {
        this.unbindHoverOpen();
      }
    });
  }

  bindHoverOpen() {
    if (this.hoverBound) return;
    this.hoverBound = true;

    this.onMouseEnter = () => {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    };

    this.onMouseLeave = () => {
      this.close();
    };

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
  }

  unbindHoverOpen() {
    if (!this.hoverBound) return;
    this.hoverBound = false;
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

function initNestedMenuHover() {
  const hoverMediaQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');

  const bindNestedMenuHover = () => {
    document
      .querySelectorAll('.header__inline-menu .header__submenu details')
      .forEach((details) => {
        if (details.dataset.hoverMenuBound === 'true') return;
        details.dataset.hoverMenuBound = 'true';

        details.addEventListener('mouseenter', () => {
          if (!hoverMediaQuery.matches) return;
          details.setAttribute('open', '');
        });

        details.addEventListener('mouseleave', () => {
          if (!hoverMediaQuery.matches) return;
          details.removeAttribute('open');
        });
      });
  };

  bindNestedMenuHover();
  hoverMediaQuery.addEventListener('change', bindNestedMenuHover);
  document.addEventListener('shopify:section:load', bindNestedMenuHover);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNestedMenuHover);
} else {
  initNestedMenuHover();
}
